import React, { createContext, useState, useContext, useEffect, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  // El panel administrativo siempre inicia en oscuro. El cambio a claro,
  // si el usuario lo elige, dura únicamente durante la sesión actual.
  const [mode, setMode] = useState('dark');

  useEffect(() => {
    // Aplicar clase al body para CSS variables
    document.body.setAttribute('data-theme', mode);
  }, [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: {
            main: mode === 'light' ? '#7a1238' : '#c27894',
            dark: mode === 'light' ? '#4d0a24' : '#8f3458',
            light: mode === 'light' ? '#a64b6e' : '#e7b6c8'
          },
          secondary: {
            main: mode === 'light' ? '#17191b' : '#f1e8dc',
            dark: mode === 'light' ? '#08090a' : '#c7b9a7',
            light: mode === 'light' ? '#414447' : '#fffaf2'
          },
          background: {
            default: mode === 'light' ? '#f5f5f5' : '#121212',
            paper: mode === 'light' ? '#ffffff' : '#1e1e1e'
          },
          text: {
            primary: mode === 'light' ? '#212121' : '#ffffff',
            secondary: mode === 'light' ? '#757575' : '#b0b0b0'
          },
          success: {
            main: mode === 'light' ? '#4caf50' : '#66bb6a'
          },
          error: {
            main: mode === 'light' ? '#f44336' : '#ef5350'
          },
          warning: {
            main: mode === 'light' ? '#ff9800' : '#ffa726'
          },
          info: {
            main: mode === 'light' ? '#2196f3' : '#42a5f5'
          }
        },
        typography: {
          fontFamily: "'Inter', 'Segoe UI', 'Helvetica', 'Arial', sans-serif"
        },
        shape: {
          borderRadius: 6
        }
      }),
    [mode]
  );

  const value = {
    mode,
    toggleTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe ser usado dentro de ThemeProvider');
  }
  return context;
};

export default ThemeContext;


